<template>
	<div id="footer">
		<div class="company">
			<div class="info">
				<h5>农夫铺子数字新零售</h5>
				<div>
					核心优势
				</div>
				<div>
					核心能力
				</div>
				<div>
					核心业务
				</div>
				<div>
					权威认证
				</div>
			</div>
			<div class="info">
				<h5>产品业务</h5>
				<div>
					收费标准
				</div>
				<div>
					产品分类
				</div>
			</div>
			<div class="info">
				<h5>项目中心</h5>
				<div>
					线上商业生态
				</div>
				<div>
					线下商业生态
				</div>
			</div>
			<div class="info4">
				<h5>联系我们</h5>
				<div>
					客服电话：400-091-8787
				</div>
				<div>
					邮件：nfpzxls@163.com
				</div>
				<div>
					公司名称：西安农夫铺子数字新零售有限公司
				</div>
				<div>
					地址：陕西省西安市浐灞生态区欧亚一路南世园大观1号楼17层1703室
				</div>
			</div>
			<div class="gzg_info">
				<img src="@/assets/img/gzh.png" alt="" />
				<div>关注公众号</div>
			</div>
		</div>

		<div class="record">
			<div>
				<span>备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index"
						target="_blank">陕ICP备2024044574号</a><span>版权：西安农夫铺子数字新零售有限公司</span>
				</span>
			</div>
			<div></div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	export default {
		name: "Footer",
		data() {
			return {
				info: '',
				domain: '',
			};
		},
		mounted() {
			// 如果需要包含协议，可以这样组合
			this.domain = `${window.location.protocol}//${window.location.hostname}`;
			// this.getInfo()
		},
		methods: {
			getInfo() {
				// 发起 POST 请求
				axios.post(this.domain + '/api/login/info')
					.then(response => {
						console.log('响应数据:', response.data);
						this.info = response.data.data
					})
					.catch(error => {
						console.error('请求出错:', error);
					});
			},
		}
	};
</script>
<style scoped>
	#footer {
		height: 357px;
		transition: all ease 0.6s;
		background: #1A2325;
		box-sizing: border-box;
		text-align: left;
	}

	.company {
		width: 57%;
		margin: 0 auto;
		/* height: 277px; */
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #3F3F3F;
	}

	.record {
		height: 80px;
		box-sizing: border-box;
		background: #1A2325;
		padding: 20px;
		font-size: 12px;
		color: #B2BFCD;
		display: flex;
		justify-content: space-around;
		text-align: center;
	}



	.gzg_info img {
		width: 120px;
		height: 120px;
		margin-top: 50px;
	}

	.gzg_info {
		text-align: center;
	}

	.gzg_info div {
		color: #B2BFCD;
		font-size: 14px;
		margin-top: 15px;
	}

	.record img {
		width: 36px;
		height: 40px;
		display: inline-block;
	}



	.record span {
		margin-left: 14px;
	}

	.info,
	.info4 {
		margin-top: 50px;

	}

	.info div,
	.info4 div {
		line-height: 30px;
		color: #B2BFCD;
		font-size: 14px;
	}

	.info h5,
	.info4 h5 {
		font-weight: 800;
		color: #FFFFFF;

	}

	@media screen and (min-width:998px) {
		.company {
			height: 277px;
		}

	}



	@media screen and (max-width: 997px) {
		.title {
			font-size: 20px;
		}

		.address_tel_fax {
			font-size: 12px;
		}

		.email_wx {

			font-size: 12px;
		}

		.copy {
			font-size: 12px;
			margin: 30px 0 10px;
		}

		.info {
			display: none;
		}

		.info4 {
			margin-top: 0px;
		}

		.company {
			width: 90%;
			padding: 30px 0;
			/* height: 220px; */
		}

		#footer {
			height: 300px;
		}

		.gzg_info {
			display: none;
		}


	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue